import React, { Component } from 'react';
import { numberFormat } from './numberFormat';
class getTotales extends Component {
  render (){
    return (
      <React.Fragment>
        <label className="lbl_total">Total: {numberFormat(this.props.lbl_total)}</label>
        <span className="lbl_informacion">
          Cuenta: {this.props.cuenta} <br/>
          Vendedor: {this.props.nombre_vendedor}
        </span>
      </React.Fragment>
    )
  }
}
export default getTotales;
